;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import classNames from 'classnames';
import './container.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
    size?: 'sm' | 'default' | 'full-width';
}

export default function Container({ children, className, size = 'default' }: Props) {
    return (
        <div className={classNames('container', `-${size}`, className)}>
            {children}
        </div>
    );
}
